export const CMAPS = 'CMAPS';
export const GENERIC = 'GENERIC';
export const NAVI_MAPS = 'NAVI_MAPS';
export const MMT = 'MMT';
export const ESSENTIAL_IMAGE = 'ESSENTIAL_IMAGE';
export const IALM = 'IALM';
